import React from "react";
import Modal from "react-modal";
import closeIcon from '../../assets/icons/close.svg'
import { Link } from "react-router-dom";
import { getDownloadPageUrl } from "../../routes/clientUrls";

import styles from './VersionModal.module.css';

type TVersionModal = {
  currentVersion: string;
  isOpen: boolean;
  version?: string,
  fileName: string;
  onClick?: () => void;
};

const VersionModal: React.FC<TVersionModal> = ({ fileName, version, onClick, isOpen, currentVersion }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClick}
      className={styles.modal}
      overlayClassName={styles.overlay}
      contentLabel="Example Modal"
      ariaHideApp={false}>
      <img
        className={styles.closeButton}
        alt="close"
        onClick={onClick}
        src={closeIcon}
      />
      <div className={styles.modalText}>
        You are about to install OLDER version ({version}) than the version you have ({currentVersion}).
        <br className={styles.br} />
        Some new settings and updated Hanging Protocols might be lost in the process.
      </div>
      <div className={`${styles.modalText} ${styles.margin}`}>
        Do you want to proceed anyway?
      </div>
      <div className={styles.buttonWrapper}>
        <button
          className={styles.cancelButton}
          onClick={onClick}>
          Cancel
        </button>
        <Link
          onClick={onClick}
          to={getDownloadPageUrl(fileName)}>
          <button className={styles.downloadButton}>
            Download anyway
          </button>
        </Link>
      </div>
    </Modal>
  );
};

export default VersionModal;